import { render, staticRenderFns } from "./UpsellPackageCard.vue?vue&type=template&id=131213a3&"
import script from "./UpsellPackageCard.vue?vue&type=script&lang=ts&"
export * from "./UpsellPackageCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports